// 组件类
import {
  AfterContentInit,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { CommonGridComponent } from "../../common-grid/index.component";
import { GridComponent } from "@syncfusion/ej2-angular-grids";
import { TreeGridComponent } from "@syncfusion/ej2-angular-treegrid";
import { SearchInputComponent } from "../../form/search-input/index.component";
import { getTranslation } from "../../utils/utils";

@Component({
  selector: "rs-grid-box",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.scss"],
})
export class GridBoxComponent implements OnInit, AfterContentInit {
  @ContentChild(CommonGridComponent, { static: false }) gridContent;
  @ContentChild(GridComponent, { static: false }) orignGrid;
  @ContentChild(TreeGridComponent, { static: false }) treeGrid;
  @ContentChild("wholeToolbarSlot", { static: false }) wholeToolbarSlot: any;
  @ViewChild("searchInput", { static: false })
  searchInput: SearchInputComponent;

  @Input() hideSearch = false;
  @Input() isInner = false;
  @Output() onGridSearch = new EventEmitter();

  hasWholeToolbarSlot: boolean = false;
  translation;

  ngOnInit() {
    this.getInfo();
  }

  getInfo() {
    this.translation = getTranslation();
  }
  ngAfterContentInit() {
    // 检测是否传入了 wholeToolbarSlot
    this.hasWholeToolbarSlot = !!this.wholeToolbarSlot;
  }

  setSearchValue(value) {
    this.searchInput.searchValue = value;
    this.onSeach(value);
  }

  onSeach(value) {
    if (this.gridContent) {
      this.gridContent.grid.search(value);
    } else if (this.orignGrid) {
      this.orignGrid.search(value);
    } else if (this.treeGrid) {
      this.treeGrid.search(value);
    } else {
      this.onGridSearch.emit(value);
    }
  }
}
